var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighFive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 190,
    viewBox: "0 0 343 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 190,
    fill: "url(#paint0_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 203.217V168.279C6.24263 174.117 39.8815 182.674 141.382 182.674C205.514 182.674 243.926 177.658 274.169 173.709C299.402 170.414 318.948 167.862 343 169.585V203.217H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.811 43.7283C221.766 39.4144 219.042 35.1434 214.729 34.1887C210.415 33.2341 206.144 35.9573 205.189 40.2712C204.922 41.4754 204.773 42.5252 204.5 44C203.783 43.5317 202.853 43.4716 201.977 43.2481C197.696 42.1562 193.34 44.7416 192.248 49.0228C191.632 51.4377 190.601 54.4959 190 58C186.426 57.8267 183.436 60.0916 182.347 63.6708C179.821 71.9696 178.5 82.5 178.5 90.5005C178.5 130.5 189.5 157 216 157C242.5 157 243 134 241 125.5C240.69 124.184 240.188 122.684 239.557 121.085C238.9 118.104 238.566 114.234 238.576 110.027C238.589 104.38 239.211 99.2845 239.788 96.8309C240.799 92.5299 238.132 88.2235 233.831 87.2122C232.514 86.9026 231.197 86.9378 229.974 87.2589C229.949 85.0073 229.99 82.6928 230.092 80.3482C230.538 70.1221 232.073 60.4947 233.287 55.3322C234.299 51.0313 231.633 46.7245 227.332 45.7125C224.624 45.0754 221.914 45.8963 220.025 47.6653C220.292 46.1958 220.557 44.8743 220.811 43.7283Z",
    fill: "url(#paint1_radial)",
    stroke: "#B661EA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 47.5C217.167 52.8333 212.6 68.7 215 87.5",
    stroke: "#B661EA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.5 44C202 54.5 197.5 72.5 200.295 90",
    stroke: "#B661EA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 58C187 68.5 186.5 85 188.961 94",
    stroke: "#B661EA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 87.5C226.167 88.8333 219.9 96.8 225.5 118",
    stroke: "#B661EA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 114C219.333 116.167 209.8 123.4 209 135",
    stroke: "#B661EA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.753 95.1203C210.063 95.3969 197.198 97.3382 191.248 102.891",
    stroke: "#B661EA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 25L173.095 37.9492",
    stroke: "#FFE195",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 30L161.5 36.5",
    stroke: "#FFE195",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 37.5L155.5 45.5",
    stroke: "#FFE195",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 34.5L182 44.5",
    stroke: "#FFE195",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 121.5C75.2 121.5 59 133.833 53 140",
    stroke: "#FFE195",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 112C267.8 112 284 124.333 290 130.5",
    stroke: "#FFE195",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5285 113.336C70.868 113.896 60.9029 120.428 57.2529 123.623",
    stroke: "#FFE195",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.472 121.336C263.132 121.896 273.097 128.428 276.747 131.623",
    stroke: "#FFE195",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.704 103.583C102.504 91.1828 108.871 90.4161 112.204 91.5828C112.204 88.7495 110.904 79.783 105.704 66.583C100.504 53.383 107.871 48.583 111.704 48.083C111.037 42.9163 111.204 34.083 119.204 33.083C127.539 32.0411 131.704 41.083 132.704 45.083C133.204 44.583 134.604 43.583 136.204 43.583C146.604 43.583 150.871 56.583 151.704 63.083C164.204 63.083 165.704 89.583 165.704 102.583C165.704 153.583 141.704 156.083 133.204 156.083C124.704 156.083 113.204 151.083 104.704 140.083C96.204 129.083 105.204 119.083 103.704 103.583Z",
    fill: "url(#paint2_radial)",
    stroke: "#EABDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 63.5C149.833 63.8333 146 66.1 148 72.5C150.5 80.5 151.5 90 151 94M133 45.5C132 46.6667 130.3 50.1 131.5 54.5C133 60 140 74.5 138.5 91.5M112 48C117 56 122.2 71.1 123 91.5",
    stroke: "#EABDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5 92C113.023 95.5309 114 108 112.5 117",
    stroke: "#EABDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.228 95.3626C121.363 97.213 121.956 98.3646 123.031 99.8695",
    stroke: "#EABDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.482 96.2479C134.614 98.0985 135.205 99.2511 136.278 100.758",
    stroke: "#EABDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.752 97.1265C147.867 98.9782 148.448 100.136 149.507 101.652",
    stroke: "#EABDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333 217) rotate(-151.421) scale(344.051 287.19)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#FFA9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8481F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(194 62.5) rotate(53.5609) scale(199.506)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0133032,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDEE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111 41) rotate(68.331) scale(120.517 63.3548)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C46BFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9330E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 190,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighFive);
export default __webpack_public_path__ + "static/media/highFive.57df82164685ad8874604e78da3140d2.svg";
export { ForwardRef as ReactComponent };